// improved WebSocket client
import { getWebSocketUrl } from "../../../config/api";

export default function createWS({ onMessage, onOpen, onClose, onError, token } = {}) {
  const MAX_DELAY = 15000;
  const PING_INTERVAL = 30000;
  let ws = null;
  let attempt = 0;
  let reconnectTimer = null;
  let pingTimer = null;
  let manualClose = false;
  let sendQueue = [];

  function buildUrl() {
    return getWebSocketUrl(token);
  }

  function connect() {
    const url = buildUrl();
    console.log("[WS] Connecting to:", url, "(attempt", attempt + 1 + ")");

    try {
      ws = new WebSocket(url);
    } catch (err) {
      console.error("[WS] New WebSocket() throw:", err);
      scheduleReconnect();
      return;
    }

    ws.onopen = (evt) => {
      console.log("[WS] open");
      attempt = 0;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      const userId = localStorage.getItem("userId");
      if (userId) {
        ws.send(
          JSON.stringify({
            type: "subscribe",
            userId,
          })
        );
        console.log("[WS] Subscribed as user:", userId);
      }
      sendQueue.forEach((m) => ws.send(JSON.stringify(m)));
      sendQueue = [];
      if (onOpen) onOpen(ws);
      pingTimer = setInterval(() => {
        if (ws && ws.readyState === WebSocket.OPEN) {
          try {
            ws.send(JSON.stringify({ type: "ping", ts: Date.now() }));
          } catch (e) {
            console.warn("[WS] ping send failed", e);
          }
        }
      }, PING_INTERVAL);
    };

    ws.onmessage = (evt) => {
      try {
        const data = JSON.parse(evt.data);
        onMessage && onMessage(data);
      } catch (err) {
        console.log("[WS] JSON parse error:", err);
        console.log("[WS] Raw message:", evt.data);
      }
    };

    ws.onerror = (ev) => {
      console.error("[WS] onerror event:", ev);
      onError && onError(ev);
    };

    ws.onclose = (evt) => {
      console.warn("[WS] onclose, code:", evt.code, "reason:", evt.reason, "wasClean:", evt.wasClean);
      if (pingTimer) clearInterval(pingTimer);
      onClose && onClose(evt);
      if (!manualClose) scheduleReconnect();
    };
  }

  function scheduleReconnect() {
    attempt += 1;
    // keep attempt from growing forever — after 10 tries cap and reset attempts slowly
    if (attempt > 12) attempt = 12;
    const base = Math.min(1000 * Math.pow(2, Math.min(attempt, 6)), MAX_DELAY);
    const jitter = Math.floor(Math.random() * 1000);
    const delay = Math.min(base + jitter, MAX_DELAY);
    console.log(`[WS] Reconnecting in ${delay}ms (attempt ${attempt})`);
    clearTimeout(reconnectTimer);
    reconnectTimer = setTimeout(connect, delay);
  }

  function close() {
    manualClose = true;
    clearTimeout(reconnectTimer);
    clearInterval(pingTimer);
    try {
      ws && ws.close(1000, "client closed");
    } catch (err) {
      console.log("[WS] Close error:", err);
    }
  }

  function send(msg) {
    try {
      if (ws && ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify(msg));
      } else {
        sendQueue.push(msg);
      }
    } catch (err) {
      console.log("[WS] Send error:", err);
    }
  }

  // start
  connect();
  return { send, close };
}
